import { useContext } from 'react';

import { MainLayoutContext } from './MainLayoutContext';

export const useMainLayout = () => useContext(MainLayoutContext);
